<div
    class="metadata-selectors__selectors flex align-items-center mr-0 xl:mr-8"
    [ngClass]="config()?.divider?.isVisible ? '' : 'gap-1 xl:gap-3'"
    data-cy="selectors-container"
>
    <p-dropdown
        appNoInitialTransition
        #facility
        placeholder="Select a facility"
        styleClass="metadata-selectors__facility"
        panelStyleClass="metadata-selectors__facility-panel"
        optionLabel="name"
        [options]="facilities()"
        [(ngModel)]="selectedFacility"
        data-cy="facility-dropdown"
    >
        <ng-template pTemplate="selectedItem">
            @if (facility.value) {
                <span class="font-semibold c-blue text-lg" data-cy="selected-facility-name">
                    {{ facility.value.name }}
                </span>
            }
        </ng-template>
        <ng-template pTemplate="item" let-facility>
            <span class="metadata-selectors__facility-name mr-2 font-medium" data-cy="facility-option-name">
                {{ facility.name }}
            </span>
            <span class="metadata-selectors__facility-address font-italic opacity-70" data-cy="facility-option-address">
                {{ facility.address1 }}
            </span>
        </ng-template>
    </p-dropdown>

    @if (config()?.divider?.isVisible) {
        <p-divider type="solid" layout="vertical" styleClass="metadata-selectors__divider--vertical"></p-divider>
    }

    @let helperText = config()?.department?.helperText(department.value);

    <div
        class="flex"
        [class.flex-column]="config()?.department?.position === 'below'"
        [ngClass]="helperText && config()?.department?.position === 'below' ? 'mt-125' : ''"
        data-cy="department-container"
    >
        <p-dropdown
            appNoInitialTransition
            #department
            placeholder="Select a department"
            styleClass="metadata-selectors__department"
            panelStyleClass="metadata-selectors__department-panel"
            optionLabel="name"
            [options]="filteredDepartments()"
            [(ngModel)]="selectedDepartment"
            data-cy="department-dropdown"
        >
            <ng-template pTemplate="selectedItem">
                @if (department.value) {
                    <span class="font-semibold c-blue text-lg" data-cy="selected-department-name">
                        {{ department.value.name }}
                    </span>
                }
            </ng-template>
            <ng-template pTemplate="item" let-department>
                <div class="flex justify-content-between align-items-center" data-cy="department-option">
                    <span class="metadata-selectors__department-name" data-cy="department-option-name">
                        {{ department.name }}
                    </span>
                    <span data-cy="department-patient-count">
                        <span class="mr-1">
                            {{ department.activePatients }}
                        </span>
                        <fa-icon [icon]="['fas', 'user']" class="c-text-grey opacity-40" />
                    </span>
                </div>
            </ng-template>
        </p-dropdown>
        @if (helperText) {
            <small
                class="h-1rem mt-1 pl-2 text-10px font-light c-blue whitespace-prewrap"
                data-cy="department-updated-at"
            >
                {{ helperText }}
            </small>
        }
    </div>
</div>
